import { ICart } from '../interfaces/Cart'
import { IProduct } from '../interfaces/Product'

export const checkCart = (cart: ICart[], products: IProduct[]) => {
    return cart.filter(c => !!products.find(p => p._id === c.product))
}